import React, { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import axios from "../api/baseurl";
import "./Spinner.css";
import "./Loader.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateCompanyDetails from "./createCompanyDetails";
import UploadCompaniesCsvFile from "./uploadCompaniesCsvFile";
import CsvFormat from "./csvFormatImage";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Pagination } from "react-bootstrap";

function CertificatesAndForms() {
  const [companyDetails, setCompanyDetails] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCsvUplaodModalOpen, setIsCsvUplaodModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const navigate = useNavigate();

  const token = JSON.parse(localStorage.getItem("data")).token;

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);  // Always start search from page 0
    } else {
      getData(currentPage); // Load normal data when search is cleared
    }
  }, [searchTerm]); // Remove `currentPage` to avoid unnecessary calls
  
  
  const searchData = async (pageNumber = 0) => {
    setLoader(true);
    try {
     const searchUrl = `/api/companydetails/searchByCompanynameOrCode`;
              const requestData = {
                searchTerm
              };
        
      const response = await axios.post(searchUrl, requestData, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompanyDetails(response.data.content);
      setCurrentPage(response.data.number);
      setTotalPages(response.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const trans = await axios.get(`/api/companydetails/getAllCompanies`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setCompanyDetails(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };
  

  
  const handleAddCertficates = () => {
    navigate(`/users/add-certificates`);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const uploadCsv = () => {
    setIsCsvUplaodModalOpen(true);
  };

  const closeUploadModal = () => {
    setIsCsvUplaodModalOpen(false);
    getData();
  };


  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const [showImageModal, setShowImageModal] = useState(false);

  const handleShowImageModal = () => setShowImageModal(true);
  const handleCloseImageModal = () => setShowImageModal(false);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };


  return (
    <div>
      <div>
        <Dashboard />
      </div>
      <div>
        <div className="col-12 mx-xl-auto ps-xl-10 mt-10">
          <div className="card card-raised ">
            <div className="card-body ">
              <div className="card-title form-group d-flex align-items-center justify-content-between">
                <span>Certificate And Forms</span>
             

                <div>

                  <button className="btn btn-primary" onClick={handleAddCertficates}>
                    ADD
                  </button>
                </div>
              </div>

              <br />
              {/* <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                    <th>Company Name</th>
                    <th>Email</th>
                   
                  </tr>
                </thead>
                <tbody>
                  {companyDetails.length === 0 ? (
                    <tr>
                      <td colSpan="10" className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  ) : (
                    companyDetails.map((accd) => (
                      <tr key={accd.comapnycode}>
                        <td
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => handleViewCompanyDetails(accd.companycode)}
                          onMouseOver={(e) => {
                            e.target.style.color = "blue";
                            e.target.style.textDecoration = "underline";
                          }}
                          onMouseOut={(e) => {
                            e.target.style.color = "";
                            e.target.style.textDecoration = "";
                          }}
                        >
                          {accd.companyname}
                        </td>
                        <td>{accd.username}</td>
                       
                      </tr>
                    ))
                  )}
                </tbody>
              </table> */}
              <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>

              <div>
                {isModalOpen && (
                  <CreateCompanyDetails isOpen={isModalOpen} onRequestClose={handleCloseModal} />
                )}
                {isCsvUplaodModalOpen && (
                  <UploadCompaniesCsvFile isOpen={isCsvUplaodModalOpen} onRequestClose={closeUploadModal} />
                )}

          {showImageModal && (
           <CsvFormat isOpen={showImageModal} onRequestClose={handleCloseImageModal} />
           )}
              </div>
            </div>
          </div>
        </div>
        {loader && <div className="loading"></div>}
      </div>
    </div>
  );
}

export default CertificatesAndForms;
